import { render, staticRenderFns } from "./CustomerSearchCard.vue?vue&type=template&id=15418df0&scoped=true"
import script from "./CustomerSearchCard.vue?vue&type=script&lang=js"
export * from "./CustomerSearchCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15418df0",
  null
  
)

export default component.exports